<template>
    <div class="styled-callout">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
    .styled-callout {
        border: 1px solid rgba($gray, 0.3);
        background-color: rgba($gray, 0.03);
        padding: 20px;
        p {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>
